export default __webpack_public_path__ + "static/media/ss2.29b2f4f4.svg";